var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuredCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11556 1.02852C8.21899 0.929377 8.35672 0.874023 8.5 0.874023C8.64328 0.874023 8.78101 0.929377 8.88444 1.02852C10.1102 2.20319 11.8551 2.84052 13.3453 3.17964C14.0827 3.34675 14.7404 3.43741 15.2129 3.4863C15.4574 3.51137 15.7025 3.52946 15.948 3.54052H15.9578C16.1028 3.54401 16.2407 3.60407 16.342 3.70788C16.4433 3.8117 16.5 3.95102 16.5 4.09608V8.42941C16.5 12.6503 14.2511 16.881 8.66578 18.6263C8.55784 18.66 8.44216 18.66 8.33422 18.6263C5.56178 17.7596 3.59289 16.2743 2.32089 14.4405C1.05289 12.6107 0.5 10.4681 0.5 8.3183V4.09608C0.499958 3.95102 0.556656 3.8117 0.657976 3.70788C0.759297 3.60407 0.897203 3.54401 1.04222 3.54052H1.052L1.08756 3.53919C1.32118 3.52776 1.55445 3.50997 1.78711 3.48586C2.41518 3.42093 3.03881 3.31853 3.65467 3.17919C5.14444 2.84052 6.88933 2.20364 8.11556 1.02852ZM12.328 7.60852C12.3823 7.55854 12.4261 7.49823 12.4568 7.43113C12.4876 7.36403 12.5046 7.29148 12.507 7.21771C12.5094 7.14394 12.497 7.07044 12.4707 7.0015C12.4444 6.93255 12.4045 6.86955 12.3536 6.81616C12.3026 6.76278 12.2415 6.72008 12.1739 6.69057C12.1062 6.66106 12.0334 6.64532 11.9596 6.64428C11.8858 6.64324 11.8125 6.65691 11.7441 6.6845C11.6756 6.71209 11.6133 6.75304 11.5609 6.80497L7.06444 11.0974L5.44844 9.48097C5.34424 9.37677 5.20292 9.31823 5.05556 9.31823C4.90819 9.31823 4.76687 9.37677 4.66267 9.48097C4.55847 9.58517 4.49993 9.7265 4.49993 9.87386C4.49993 10.0212 4.55847 10.1625 4.66267 10.2667L6.66267 12.2667C6.876 12.4801 7.22089 12.4845 7.43911 12.2756L12.328 7.60852Z",
    fill: "url(#paint0_linear_4847_63896)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4847_63896",
    x1: 0.5,
    y1: 0.874023,
    x2: 16.8276,
    y2: 1.18014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuredCall);
export default __webpack_public_path__ + "static/media/secured-call.3f4333fb4181870f7393a9e66880a265.svg";
export { ForwardRef as ReactComponent };